import { FETCH_NOTIFICATIONS, CLEAR_NOTIFICATIONS } from "../_actions/types";
const defaultState = {
  notifications: []
};

export default function(state = defaultState, action) {
  switch (action.type) {
    case FETCH_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload
      };
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: []
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/common/common_reducer.js